import '../css/top.scss'
import { initBottomCvArea } from './ui/bottom_cv_area'
import { initSmoothAnchorLinks } from './ui/smooth_anchor_links'

export function initTopPage() {
  initBottomCvArea()
  initSmoothAnchorLinks()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTopPage)
} else {
  initTopPage()
}
